import { render } from "./OrderTimer.vue?vue&type=template&id=56ad3138"
import script from "./OrderTimer.vue?vue&type=script&lang=js"
export * from "./OrderTimer.vue?vue&type=script&lang=js"

import exportComponent from "/home/scotty/git/kds-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__